module.exports = function(id) {
  document.getElementById(id).scrollIntoView({
    behavior: 'smooth',
  });
  setTimeout(function() {
    window.location.hash = id;
  }, 1000);
}
